import React, { useState, useRef } from "react"
import { css } from "@emotion/react"

import { color } from "../defaults/styles/theme"
import mq from "../defaults/styles/mediaquerys"
import {
  IconButton,
  IconButtonDropdown,
  LogoCard,
} from "../defaults/styles/elements"
import ArrowUpRight from "../defaults/assets/svg/arrow-up-right.svg"
import Flags from "../../data/raw/flags"
import Link from "../link"
import publishFilter from "../defaults/filters/publish"
import passLockFilter from "../defaults/filters/passLockFilter"
import recordFilter from "../defaults/filters/record"
import getCompany from "../defaults/filters/getCompany"
import moment from "moment"

const resetcss = css`
  margin: 0;
  padding: 0;
`

const Tag = ({ tag }) => {
  return (
    <p
      css={[
        resetcss,
        css`
          color: ${["Mobility", "Production", "Enterprise"].includes(tag)
            ? color.main_dark
            : color.main_dark};
          background: ${tag === "Mobility"
            ? color.e23rose
            : tag === "Production"
            ? color.e23violette
            : tag === "Enterprise"
            ? color.e23blue
            : tag === "Sustainability"
            ? color.e23green
            : "white"};
          border-radius: 5px;
          padding: 0.75em 1.5em;
          font-size: 0.65em;
          text-transform: uppercase;
          font-weight: 900;
          letter-spacing: 0.07em;
          line-height: 1em;
          margin: 0.5em 0;
          :not(:last-of-type) {
            margin-right: 0.75em;
          }
        `,
      ]}
    >
      {tag}
    </p>
  )
}

const Time = ({ time, utc, date }) => {
  let display_time =
    Flags.settings.timezone.autoConversion === true
      ? time
      : moment(date).utcOffset(Flags.settings.timezone.offset).format("HH:mm")
  return (
    <div
      css={css`
        display: flex;
        flex-direction: column;
        align-items: flex-end;
      `}
    >
      <time
        css={[
          resetcss,
          css`
            color: white;
            font-size: 1.65rem;
            font-weight: 700;
          `,
        ]}
      >
        {display_time}
      </time>
      <span
        css={css`
          color: white;
          font-size: 0.6em;
          margin-top: -0.75em;
          text-align: right;
          ${mq[1]} {
            margin-bottom: 0.5em;
          }
        `}
      >
        {utc} (UTC)
      </span>
    </div>
  )
}

const Title = ({ title }) => {
  const titleStyle = css`
    color: white;
    font-size: 1.15rem;
    line-height: 1.35em;
    font-weight: 500;
    max-width: 40rem;
    ${mq[1]} {
      font-size: 1.35rem;
    }
  `

  if (title.includes("T-Systems")) {
    let modifiedTitle =
      "<h3>" + title.replace(/T-Systems/gi, "T&#8209;Systems") + "</h3>"

    return (
      <div
        dangerouslySetInnerHTML={{ __html: modifiedTitle }}
        css={css`
          h3 {
            ${resetcss}
            ${titleStyle}
          }
        `}
      />
    )
  } else {
    return <h3 css={[resetcss, titleStyle]}>{title}</h3>
  }
}

const TagLine = ({ partners, startups, teaser }) => {
  return teaser ||
    (startups && startups.length > 0) ||
    (partners && partners.length > 0) ? (
    <div
      css={css`
        display: flex;
        margin: 0.5em 0 1em;
        max-width: 35rem;
        width: 90%;
        /* ${mq[1]} {
          margin-top: 0;
        } */
      `}
    >
      <p
        css={[
          resetcss,
          css`
            color: white;
            opacity: 0.3;
            font-size: 0.75em;
            line-height: 1.5em;
            ${mq[1]} {
              font-size: 0.85em;
            }
          `,
        ]}
      >
        {teaser ? (
          teaser
        ) : (
          <>
            <span>with </span>
            {partners && partners.length > 0
              ? partners.map((partner, index) => (
                  <span key={index}>
                    <b>{partner.data.name}</b>

                    {index + 1 < partners.length ? ", " : ""}
                  </span>
                ))
              : ""}
            {partners && partners.length > 0 && startups && startups.length > 0
              ? " & "
              : ""}
            {startups && startups.length > 0
              ? startups.map((startup, index) => (
                  <span key={index}>
                    <b>{startup.data.startup}</b>

                    {index + 1 < startups.length ? ", " : ""}
                  </span>
                ))
              : ""}
          </>
        )}
      </p>
    </div>
  ) : (
    ""
  )
}

const Duration = ({ duration }) => {
  return duration ? (
    <p
      css={[
        resetcss,
        css`
          color: white;
          margin-left: 1em;
          ${mq[1]} {
            margin-left: 0;
          }
        `,
      ]}
    >
      {duration} h
    </p>
  ) : (
    ""
  )
}

const Stage = ({ stage }) => {
  return (
    <div
      css={css`
        color: white;
        border: 2px solid ${color.plue300};
        border-radius: 5px;
        padding: 0.1em 0.5em 0.15em;
        position: relative;
        min-width: 4em;
        text-align: center;
        max-width: 100%;
        margin-bottom: 2px;
        ${mq[1]} {
          margin-top: 3em;
          margin-bottom: 0;
        }
        p {
          margin-bottom: 0;
          line-height: 1.3em;
        }
      `}
    >
      <p
        css={css`
          position: absolute;
          bottom: calc(100% + 3px);
          right: 0;
          text-transform: uppercase;
          font-weight: 700;
          font-size: 0.75em;
          opacity: 0.5;
        `}
      >
        Stage
      </p>
      <p
        css={css`
          overflow-x: hidden;
          white-space: nowrap;
          max-width: 100%;
          text-overflow: ellipsis;
          font-size: 0.75em;
          color: ${color.plue300};
        `}
      >
        {stage === "one"
          ? "Main Stage"
          : stage === "two"
          ? "Outdoor Stage"
          : stage === "three"
          ? "Roundtable"
          : stage === "four"
          ? "Side Event"
          : stage}
      </p>
    </div>
  )
}

const Description = ({ content }) => {
  return content ? (
    <div
      dangerouslySetInnerHTML={{ __html: content }}
      css={css`
        color: white;
        max-width: 40rem;
        margin-bottom: 1.5em;
        margin-top: 2em;
        font-size: 0.75em;
        p {
          margin-bottom: 0.45em;
        }
        a {
          color: white;
        }
        ul {
          li {
            margin-bottom: 0.25em;
          }
        }
      `}
    />
  ) : (
    ""
  )
}

// const OnStage = ({speakers, hosts, narrow}) => {
//   const people_frame = css`
//     :not(:first-of-type) {
//       margin-top: 1em;
//     }
//     ${mq[2]} {
//       :not(:first-of-type) {
//         margin-top: ${narrow ? "1em" : "0"};
//         margin-left: ${narrow ? "0" : "1.5em"};
//       }
//     }
//   `

//   const people_title = css`
//     color: white;
//     font-size: .75em;
//     margin-bottom: .5em;
//   `

//   return speakers || hosts ? (
//     <div
//       css={css`
//         display: flex;
//         margin-top: 2em;
//         flex-direction: column;
//         max-width: 60rem;
//         ${mq[2]} {
//           flex-direction: ${narrow ? "column" : "row"};
//         }
//       `}
//     >
//       {speakers && speakers.length > 0 ? (
//         <div
//           css={[
//             people_frame,
//             css`
//               flex: 0 0 calc(100% / 3 * 2 - 1em);
//             `,
//           ]}
//         >
//           <p css={people_title}>
//             {speakers.length > 1 ? "Speakers" : "Speaker"} of this Session
//           </p>
//           <People speakers={speakers} />
//         </div>
//       ) : (
//         ""
//       )}
//       {hosts && hosts.length > 0 ? (
//         <div
//           css={[
//             people_frame,
//             css`
//               flex: 0 0 calc(100% / 3 - 1em);
//             `,
//           ]}
//         >
//           <p css={people_title}>
//             {hosts.length > 1 ? "Hosts" : "Host"} of this Session
//           </p>
//           <People speakers={hosts} single narrow={narrow} />
//         </div>
//       ) : (
//         ""
//       )}
//     </div>
//   ) : (
//     ""
//   )
// }

export const People = ({ speakers, single, narrow }) => {
  return (
    <div
      css={css`
        display: flex;
        width: 100%;
        flex-wrap: wrap;
        justify-content: space-between;
      `}
    >
      {speakers.map((speaker, index) => (
        <PeopleEl
          id={speaker.recordId}
          single={single}
          narrow={narrow}
          key={index}
          name={speaker.data.name}
          profession={speaker.data.profession}
          company={
            // speaker.data.partner_company && speaker.data.partner_company.length > 0 ? speaker.data.partner_company[0].data.name : speaker.data.startup_company && speaker.data.startup_company.length > 0 ? speaker.data.startup_company[0].data.startup : speaker.data.custom_company ? speaker.data.custom_company : ''
            getCompany(speaker, {
              outputAll: false,
              filterIncludes: false,
            })?.name
          }
        />
      ))}
      <PeopleEl placeholder />
    </div>
  )
}

const PeopleEl = ({
  name,
  profession,
  company,
  image,
  placeholder,
  single,
  narrow,
  id,
}) => {
  return (
    <Link
      to={"/people/" + id}
      css={css`
        background: white;
        text-decoration: none;
        color: ${color.main_dark};
        border-radius: 5px;
        padding: ${placeholder ? "" : "0.6em 1em"};
        display: inline-flex;
        flex-direction: column;
        margin: 0.25em 0;
        visibility: ${placeholder ? "hidden" : "visible"};
        min-width: 0;
        flex: 0 0 100%;
        :first-of-type {
          margin-left: 0;
        }
        :last-of-type {
          margin-right: 0;
        }
        ${mq[1]} {
          flex: 0 0 calc((100% - 0.5em) / 2);
        }
        ${mq[2]} {
          flex: 0 0 ${single && !narrow ? "100%" : "calc((100% - 0.5em) / 2)"};
        }
        p {
          margin: 0;
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
        }
      `}
    >
      <p
        css={css`
          font-weight: 700;
          font-size: 0.75rem;
        `}
      >
        {name}
      </p>
      <p
        css={css`
          font-size: 0.65em;
        `}
      >
        {profession && profession.length > 65
          ? profession.substring(0, 65).concat("...")
          : profession}
      </p>
      <p
        css={css`
          font-size: 0.65em;
        `}
      >
        {company}
      </p>
    </Link>
  )
}

const HostedBy = ({ partners, startups, narrow }) => {
  const logoArray = [partners, startups]
  const hosts = []

  logoArray.forEach((group, index) => {
    if (group && group.length > 0 && group[0].data.name) {
      group.sort((a, b) => (a.data.name > b.data.name ? 1 : -1))
    } else if (group && group.length > 0) {
      group.sort((a, b) => (a.data.startup > b.data.startup ? 1 : -1))
    }

    if (group && group.length > 0) {
      group.forEach(e => {
        hosts.push(e)
      })
    }
  })

  const CustomLogoCard = css`
    ${mq[1]} {
      flex: 0 0 calc((100% - (0.75em * 3)) / 4);
    }
    ${mq[2]} {
      flex: ${narrow ? "" : "0 0 calc((100% - (0.75em * 4)) / 5)"};
    }
  `

  return (
    <div>
      <p
        css={css`
          color: white;
          font-size: 0.75em;
          margin: 2em 0 1em;
          font-weight: 600;
        `}
      >{`Host${hosts && hosts.length > 1 ? "s" : ""} of this session`}</p>
      <div
        css={css`
          display: flex;
          flex-wrap: wrap;
          justify-content: space-between;
          max-width: 45rem;
        `}
      >
        {hosts.map((host, index) => (
          <LogoCard
            key={index}
            startup={host.data.startup ? true : false}
            partner={!host.data.startup ? true : false}
            recordId={host.recordId}
            name={host.data.startup ? host.data.startup : host.data.name}
            design={CustomLogoCard}
            passwordProtected={
              host.data.startup ? host.data.password_protected : undefined
            }
          />
        ))}
        <LogoCard placeholder design={CustomLogoCard} />
        <LogoCard placeholder design={CustomLogoCard} />
        <LogoCard placeholder design={CustomLogoCard} />
        <LogoCard placeholder design={CustomLogoCard} />
      </div>
    </div>
  )
}

const ExtendButton = ({ onClick, activeAgenda }) => {
  return (
    <div
      role="button"
      tabIndex="0"
      onClick={onClick}
      onKeyDown={onClick}
      css={css`
        background: none;
        margin-top: 1em;
        padding: 0;
        border: none;
        display: flex;
        align-items: flex-end;
        flex-direction: row;
        width: 100%;
        bottom: 0;
        left: 0;
        justify-content: flex-start;
        outline: none;
        position: absolute;
        height: 5rem;
        cursor: pointer;
        background: linear-gradient(
          to bottom,
          hsla(0, 0%, 7%, 0) 0%,
          hsla(0, 0%, 7%, 0.066) 7.9%,
          hsla(0, 0%, 7%, 0.133) 14.1%,
          hsla(0, 0%, 7%, 0.203) 19%,
          hsla(0, 0%, 7%, 0.273) 23%,
          hsla(0, 0%, 7%, 0.343) 26.4%,
          hsla(0, 0%, 7%, 0.414) 29.4%,
          hsla(0, 0%, 7%, 0.484) 32.6%,
          hsla(0, 0%, 7%, 0.554) 36.1%,
          hsla(0, 0%, 7%, 0.622) 40.3%,
          hsla(0, 0%, 7%, 0.689) 45.6%,
          hsla(0, 0%, 7%, 0.753) 52.3%,
          hsla(0, 0%, 7%, 0.815) 60.8%,
          hsla(0, 0%, 7%, 0.874) 71.3%,
          hsla(0, 0%, 7%, 0.929) 84.3%,
          hsla(0, 0%, 7%, 0.98) 100%
        );
      `}
    >
      <svg
        css={css`
          stroke: white;
          height: 1em;
          transform: ${activeAgenda ? "rotate(-90deg)" : "rotate(0)"};
          transition: transform 0.4s ease-in-out;
        `}
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 24 24"
        fill="none"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <polyline points="9 18 15 12 9 6"></polyline>
      </svg>
      <p
        css={css`
          color: white;
          font-size: 0.75em;
          margin-bottom: 0;
          margin-left: 1em;
        `}
      >
        Read more
      </p>
    </div>
  )
}

const ActionBar = ({
  recordId,
  registration,
  limit,
  rearview,
  url,
  password_protected,
  isToday,
}) => {
  const ActionButtonStyle = css`
    z-index: 1;
    display: inline-flex;
    align-items: center;
    padding: 0.61em 1.2em;
    :not(:last-of-type) {
      margin-right: 1em;
    }
    &:before {
      border: none;
      background: white;
      opacity: 0.25;
    }
  `
  return (
    <div
      css={css`
        margin-top: 2.5em;
      `}
    >
      <IconButton
        name={`
          Open Details
          ${
            Flags.features.live && isToday && url
              ? " & Join Session"
              : Flags.features.registration &&
                registration &&
                limit &&
                limit > 0
              ? " & Apply"
              : Flags.features.registration && registration
              ? " & Sign Up"
              : Flags.features.rearview && rearview && rearview.length > 0
              ? " & Access Recording"
              : ""
          }`}
        icon={<ArrowUpRight />}
        //to={`/${Flags.settings.protectedArea.url}/agenda/${recordId}`}
        to={passLockFilter(
          `/agenda/${recordFilter(recordId)}`,
          password_protected
        )}
        css={[
          ActionButtonStyle,
          (Flags.features.live && isToday && url) ||
          (Flags.features.rearview && rearview && rearview.length > 0)
            ? css`
                color: ${color.main_dark};
                svg {
                  stroke: ${color.main_dark};
                }
                &:before {
                  background: ${color.plue300};
                  opacity: 1;
                  border: none;
                }
              `
            : "",
        ]}
      />

      {/* <IconButton
        name="Add to calendar"
        icon={<Calendar />}
        css={ActionButtonStyle}
        to={`/calendar-feed/expo10-event-${recordId}.ics`}
      /> */}
    </div>
  )
}

const AgendaEl = ({
  recordId,
  className,
  title,
  date,
  start,
  start_utc,
  duration,
  description,
  tags,
  teaser,
  startups,
  partners,
  narrow,
  registration,
  limit,
  rearview,
  password_protected,
  stage,
  url,
}) => {
  const [activeAgenda, setActiveAgenda] = useState("")
  const [agendaHeight, setAgendaHeight] = useState("5rem")
  const agendaContent = useRef(null)

  const toggleCollapsableAgenda = () => {
    setActiveAgenda(activeAgenda === "" ? "active" : "")
    setAgendaHeight(
      activeAgenda === "active"
        ? "5rem"
        : `${agendaContent.current.scrollHeight + 80}px`
    )
  }

  const isToday = date.substring(0, 10) === Flags.settings.live.date

  return (
    <div
      className={className}
      css={css`
        background: ${color.main_dark};
        padding: 1em;
        opacity: ${Flags.features.live &&
        date.substring(0, 10) < Flags.settings.live.date
          ? 0.25
          : 1};
        display: flex;
        flex-direction: column;
        border-radius: 5px;
        ${mq[1]} {
          padding: 1.5em 2em;
          flex-direction: row;
        }
      `}
    >
      <div
        css={css`
          display: flex;
          width: 100%;
          justify-content: space-between;
          align-items: flex-end;
          ${mq[1]} {
            flex-direction: column;
            max-width: 5.5em;
          }
        `}
      >
        <div
          css={css`
            display: flex;
            flex-direction: row;
            align-items: baseline;
            ${mq[1]} {
              align-items: flex-end;
              flex-direction: column;
            }
          `}
        >
          <Time time={start} utc={start_utc} date={date} />
          <Duration duration={duration} />
        </div>
        {stage && <Stage stage={stage} />}
      </div>
      <div
        css={css`
          margin-top: 1.5em;
          ${mq[1]} {
            margin-top: 0;
            padding-left: 3rem;
            flex: 0 1 100%;
            display: flex;
            flex-direction: column;
            justify-content: space-between;
          }
        `}
      >
        <div
          css={css`
            margin-bottom: ${Flags.features.agenda === true ? "0" : "1em"};
          `}
        >
          <Title title={title} />
          <TagLine teaser={teaser} partners={partners} startups={startups} />
          {tags && tags.length > 0 ? (
            <div
              css={css`
                display: flex;
                flex-wrap: wrap;
                margin-top: 0.5em;
              `}
            >
              {tags.map((tag, index) => (
                <Tag tag={tag} key={index} />
              ))}
            </div>
          ) : (
            ""
          )}
          {description ? (
            <div
              ref={agendaContent}
              css={css`
                height: ${agendaHeight};
                overflow: hidden;
                transition: height 0.4s ease-in-out;
                position: relative;
              `}
            >
              <ExtendButton
                onClick={toggleCollapsableAgenda}
                className={activeAgenda}
                activeAgenda={activeAgenda}
              />
              <Description content={description} />
              {/* <OnStage speakers={speakers} hosts={hosts} narrow={narrow} /> */}
              {(partners && partners.length > 0) ||
              (startups && startups.length > 0) ? (
                <HostedBy
                  partners={partners}
                  startups={startups}
                  narrow={narrow}
                />
              ) : (
                ""
              )}
            </div>
          ) : (
            ""
          )}
        </div>
        {Flags.features.agenda === true && (
          <ActionBar
            recordId={recordId}
            url={url}
            isToday={isToday}
            registration={registration}
            limit={limit}
            rearview={publishFilter(rearview, "publish")}
            password_protected={password_protected}
          />
        )}
      </div>
    </div>
  )
}

export default AgendaEl
